import Swiper from 'swiper/dist/js/swiper.js';

var arWorkSwiper = [];
window.arWorkSwiper = arWorkSwiper;

function initWorkSwiper($container, index) {
    var $el = $container,
    $elPag = $el.find('.swiper-pagination--work'),
    $elNavLeft = $el.find('.swiper-button-next--work'),
    $elNavRight = $el.find('.swiper-button-prev--work'),
    $elFraction = $el.find('.swiper-fraction--work');

    $el.addClass(`js-swiper--work-${index}`);
    $elPag.addClass(`swiper-pagination--work-${index}`);
    $elNavLeft.addClass(`swiper-button-next--work-${index}`);
    $elNavRight.addClass(`swiper-button-prev--work-${index}`);
    $elFraction.addClass(`swiper-fraction--work-${index}`);

    return new Swiper(`.js-swiper--work-${index}`, {
        lazy: true,
        spaceBetween: 0,
        loop: false,
        speed: 900,
        autoHeight: true,
        simulateTouch: false,
        init: false,
        mousewheel: false,
        pagination: {
            el: `.swiper-pagination--work-${index}`,
            type: 'fraction',
        },
        navigation: {
            nextEl: `.swiper-button-next--work-${index}`,
            prevEl: `.swiper-button-prev--work-${index}`,
        }
    });
}

$('.js-swiper--work').each(function (index) {
    arWorkSwiper[index] = {
        key: index,
        swiper: initWorkSwiper($(this), index)
    }
    arWorkSwiper[index].swiper.init();
});

var interviewSwiper = new Swiper('.js-swiper--interview', {
    pagination: {
        el: '.swiper-pagination--interview',
        clickable: true,
        renderBullet: function (index, className) {
            var imgSrc = $(this.slides[index]).data('img');
            return '<span class="' + className + '"><img src="' + imgSrc + '" class="interview__img"></span>';
        }
    }
});

var allExperts = localize({
    en: 'All experts',
    ru: 'Все эксперты'
});

$('.swiper-pagination--interview').append('<a href="/press-center/experts/" class="interview__more">' + allExperts + '</a>');



// WEBPACK FOOTER //
// ./frontend/components/slider/slider.js